module.exports = __webpack_public_path__ + "img/illustrate.fb5b98ac.png";